import { useEffect } from 'react';
import NoticePopupModal from 'src/components/NoticePopupModal';
import { useClientControlPopup } from 'src/hooks/useClientControlPopup';
import useLogin from 'src/hooks/useLogin';
import { useNoticePopupQuery } from 'src/hooks/usePopupQuery';
import { ModalType } from 'src/types/Modal';
import { OrderedModalHookType } from './types';
import withLoginUserModalPromise from './withLoginUserModalPromise';
const useNoticePopupModal: OrderedModalHookType = modalPropsPromise => {
  const {
    setDisplayTime,
    setIsResolved,
    shouldDisplayPopup
  } = useClientControlPopup();
  const {
    data,
    isFetching: isFetchingNoticePopup
  } = useNoticePopupQuery();
  const {
    isLogin
  } = useLogin();
  useEffect(() => {
    if (!isLogin) return;
    if (isFetchingNoticePopup) return;
    const noticePopups = data?.data.popups;
    if (!noticePopups) {
      modalPropsPromise?.resolve(null);
    } else {
      modalPropsPromise?.resolve(noticePopups.filter(noticePopup => shouldDisplayPopup(noticePopup.popup.popupId, noticePopup.displayIntervalInMinutes)).map(noticePopup => {
        return {
          modalProps: {
            key: ModalType.NOTICE_POPUP,
            component: () => <NoticePopupModal popup={noticePopup.popup} onDisplay={() => setDisplayTime(noticePopup.popup.popupId)} />
          },
          eventParams: {
            popup_id: noticePopup.popup.popupId
          }
        };
      }));
    }
  }, [data?.data.popups, setDisplayTime, setIsResolved, isFetchingNoticePopup, isLogin, modalPropsPromise, shouldDisplayPopup]);
};
export default withLoginUserModalPromise(useNoticePopupModal);